import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import defaultAttrs from '../../lib/utils/defaultAttrs';

const borderColor = themeGet('colors.black.10');
const textColor = themeGet('colors.black.100');
const hoverBackgroundColor = 'rgba(229, 242, 255, 0.5)';

export const Table = styled.table`
  padding-top: 15px;
  border-collapse: separate;
  table-layout: fixed;
  box-shadow: inset 0 -1px var(--gray-3);
  width: 100%;

  td {
    height: 44px;
  }
`;

export const Tr = styled.tr`
  &:hover {
    background: transparent !important;
  }
`;

export const ShadedTr = styled.tr`
  &:hover {
    background-color: ${hoverBackgroundColor} !important;
  }
  transition: background-color 0.1s ease-out;
`;

export const ShadedTrBorder = styled(ShadedTr)`
  height: 40px;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    right: 24px;
    left: 24px;
    height: 1px;
    border-top: 1px solid ${themeGet('colors.black.10')};
  }
`;

export const Td = styled.td`
  padding: 0 15px 0 0;
  border: none !important;
  font-size: 12px;

  position: relative;
  top: 1px;
  &:after {
    content: '';
    position: absolute;
    top: -1px;
    left: 0px;
    height: 1px;
    width: 100%;
    background-color: ${themeGet('colors.black.10')};
  }
  &:first-child:after {
    width: calc(100% - 24px);
    right: 0px;
    left: auto;
  }
  &:last-child:after {
    width: calc(100% - 24px);
  }
  &:first-child {
    padding: 0 15px 0 24px;
  }
  &:last-child {
    padding-right: 24px;
  }

  @media (min-width: 800px) {
    font-size: 14px;
  }
`;

export const TdRight = styled(Td)`
  padding: 0;
  text-align: right;
`;

export const TableIcon = styled.img`
  height: 24px;
  width: 24px;
  vertical-align: initial;
  margin-top: 3px;
  border-radius: 15%;
  background: ${borderColor};
  border: none;
`;

export const Text = styled.span`
  color: ${props =>
    props.color ? themeGet(`colors.${props.color}`) : textColor};
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.2px;
  text-align: left;
`;

export const Paragraph = styled(Text).attrs(
  defaultAttrs({
    as: 'p',
    textAlign: 'initial',
  }),
)`
  max-height: 1.4em;
  margin: 12px 0;
  transition: max-height 0.5s ease-in;
  text-align: ${props => props.textAlign};
`;

export const ParagraphWithEllipsis = styled(Paragraph)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Th = styled.th.attrs(
  defaultAttrs({
    textAlign: 'left',
  }),
)`
  color: ${textColor};
  border: none;
  font-size: 14px;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: 0.1px;
  text-align: ${props => props.textAlign};
  padding: 0 0 16px 0;
  white-space: nowrap;

  &:first-child {
    padding: 0 15px 16px 24px;
  }
`;

export const ThContentWrapper = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  cursor: pointer;
  align-items: center;
`;

export const ThContentWrapperRight = styled(ThContentWrapper)`
  text-align: right;
  justify-content: flex-end;
`;

export const ColumnTitle = styled.p`
  padding: 0 8px;
  margin: 0;
`;

export const LineBreak = styled.div`
  width: calc(100% - 48px);
  border-top: 1px solid ${themeGet('colors.black.10')};
  margin: 0 24px;
`;

export const Link = styled.a`
  color: ${themeGet('colors.primary.100')};

  &:hover {
    color: ${themeGet('colors.primary.80')};
  }

  &:active {
    color: ${themeGet('colors.primary.120')};
  }
`;
